import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrustAi = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 60,
			height: 60,
			fill: ""
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.095 2.10811C8.96123 1.97167 8.96123 1.75336 9.095 1.61692L9.53836 1.16471C9.67213 1.02826 9.88616 1.02826 10.0199 1.16471C10.1537 1.30115 10.1537 1.51946 10.0199 1.6559L9.57658 2.10811C9.5116 2.17438 9.4237 2.20947 9.33579 2.20947C9.24788 2.20947 9.1638 2.17438 9.095 2.10811ZM7.8261 2.91507C7.69233 3.05151 7.69233 3.26982 7.8261 3.40627C7.89107 3.47254 7.97898 3.50762 8.06688 3.50762C8.15479 3.50762 8.23887 3.47254 8.30767 3.40627L8.75102 2.95405C8.88479 2.81761 8.88479 2.5993 8.75102 2.46286C8.61725 2.32642 8.40322 2.32642 8.26945 2.46286L7.8261 2.91507ZM6.42724 13.8929L5.98389 14.3451C5.85012 14.4815 5.85012 14.6998 5.98389 14.8363C6.04887 14.9025 6.13677 14.9376 6.22468 14.9376C6.31259 14.9376 6.39667 14.9025 6.46546 14.8363L6.90882 14.3841C7.04259 14.2476 7.04259 14.0293 6.90882 13.8929C6.77505 13.7564 6.56101 13.7564 6.42724 13.8929ZM8.17772 13.0859C8.31149 12.9495 8.31149 12.7312 8.17772 12.5947C8.04395 12.4583 7.82992 12.4583 7.69615 12.5947L7.2528 13.0469C7.11903 13.1834 7.11903 13.4017 7.2528 13.5381C7.31777 13.6044 7.40568 13.6395 7.49358 13.6395C7.58149 13.6395 7.66557 13.6044 7.73437 13.5381L8.17772 13.0859ZM7.66175 10.4935C7.66175 9.30839 6.71772 8.34549 5.55583 8.34549C5.36855 8.34549 5.21567 8.18956 5.21567 7.99854C5.21567 7.80752 5.36855 7.65158 5.55583 7.65158C6.71772 7.65158 7.66175 6.68869 7.66175 5.50358C7.66175 5.31256 7.81463 5.15663 8.00191 5.15663C8.18919 5.15663 8.34207 5.31256 8.34207 5.50358C8.34207 6.68869 9.2861 7.65158 10.448 7.65158C10.6353 7.65158 10.7882 7.80752 10.7882 7.99854C10.7882 8.18956 10.6353 8.34549 10.448 8.34549C9.2861 8.34549 8.34207 9.30839 8.34207 10.4935C8.34207 10.6845 8.18919 10.8404 8.00191 10.8404C7.81463 10.8404 7.66175 10.6845 7.66175 10.4935ZM8.00191 9.13686C8.25798 8.65736 8.64783 8.26363 9.11411 8.00244C8.64401 7.74125 8.25798 7.34361 8.00191 6.86801C7.74584 7.34751 7.35599 7.74125 6.88971 8.00244C7.35981 8.26363 7.74584 8.66126 8.00191 9.13686ZM6.49986 13.3081C6.58395 13.273 6.64892 13.2068 6.68332 13.121C6.69861 13.0781 6.71007 13.0352 6.71007 12.9884V11.6708C6.71007 11.4798 6.55719 11.3238 6.36991 11.3238C6.18264 11.3238 6.02976 11.4798 6.02976 11.6708V12.1503L1.95932 7.99854L8.2427 1.59353C8.37647 1.45708 8.37647 1.23877 8.2427 1.10233C8.10893 0.965889 7.89489 0.965889 7.76112 1.10233L1 7.99854L5.55201 12.6415H5.0819C4.89462 12.6415 4.74174 12.7974 4.74174 12.9884C4.74174 13.1795 4.89462 13.3354 5.0819 13.3354H6.37374C6.4196 13.3354 6.46164 13.3276 6.50369 13.3081H6.49986ZM10.4518 3.35559H10.9219C11.1092 3.35559 11.2621 3.19965 11.2621 3.00863C11.2621 2.81761 11.1092 2.66168 10.9219 2.66168H9.63008C9.58422 2.66168 9.54218 2.66947 9.50014 2.68897C9.41605 2.72405 9.35108 2.79032 9.31668 2.87609C9.30139 2.91897 9.28993 2.96185 9.28993 3.00863V4.32628C9.28993 4.5173 9.44281 4.67323 9.63008 4.67323C9.81736 4.67323 9.97024 4.5173 9.97024 4.32628V3.84678L14.0407 7.99854L7.7573 14.4074C7.62353 14.5439 7.62353 14.7622 7.7573 14.8986C7.82228 14.9649 7.91018 15 7.99809 15C8.086 15 8.17008 14.9649 8.23887 14.8986L15 8.00244L10.448 3.35948L10.4518 3.35559Z",
			fill: "url(#paint0_linear_47434_8657)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_47434_8657",
			x1: 8.00191,
			y1: 15,
			x2: 8.00191,
			y2: 1.00097,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#6FBE46" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .34,
					stopColor: "#41B57F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .63,
					stopColor: "#1EAEAB"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .86,
					stopColor: "#08AAC5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#00A8CF"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgTrustAi);
export default ForwardRef;
